import { router } from "expo-router";
import React, { useImperativeHandle, useRef } from "react";
import { View } from "react-native";

import Pressable from "$src/core/components/atoms/Pressable";
import Card from "$src/core/components/molecules/Card/Card";
import type { GridProps } from "$src/core/components/organisms/Grid/types";
import type { ContentDto } from "$src/core/models/dto";

import $, { IMAGE_DIMENSIONS } from "./Grid.web.styles";

const Grid = ({ ref, items, onItemPress }: GridProps) => {
  const itemRefs = useRef<View[]>([]);

  useImperativeHandle(ref, () => ({
    requestFocusOnIndex: (index: number) => {
      itemRefs.current.at(index)?.focus();
    },
  }));

  const handleItemPress = (item: ContentDto) => {
    router.push(`/${item.type}/${item.id}`);
    onItemPress?.(item);
  };

  return (
    <View style={$.grid}>
      {items.map((item, index) => (
        <Pressable
          key={item.id}
          ref={(el: View | null) => {
            if (el) itemRefs.current[index] = el;
          }}
          onPress={() => handleItemPress(item)}
          accessibilityRole="button"
          style={$.pressable}
        >
          <Card
            type="portrait"
            title={item.title}
            image={item.image ?? item.images}
            progress={item.progress}
            cardStyle={$.card}
            imageDimensions={IMAGE_DIMENSIONS.card}
          />
        </Pressable>
      ))}
    </View>
  );
};

export default Grid;
